module.exports = __webpack_public_path__ + "static/feature-1-3886bd32bdbbb5320b7271e1b3ee24a1.mp4";